import type {
  SelllistResponse,
  ListItemRef,
  SharedSelllistResponse,
  ShareTokenResponse,
  MarkSelllistItemSoldResponse,
} from '@/types'
import { request } from './client'

export async function getSelllist(): Promise<SelllistResponse> {
  return request<SelllistResponse>('/selllist')
}

export async function addToSelllist(
  cardId: number,
  quantity: number = 1,
  idempotencyKey?: string,
): Promise<ListItemRef> {
  const response = await request<{ selllistItem: ListItemRef }>('/selllist', {
    method: 'POST',
    body: { cardId, quantity },
    idempotencyKey,
  })
  return response.selllistItem
}

export async function removeFromSelllist(cardId: number, idempotencyKey?: string, all?: boolean): Promise<void> {
  const query = all ? '?all=true' : ''
  await request<void>(`/selllist/card/${cardId}${query}`, { method: 'DELETE', idempotencyKey })
}

export async function bulkRemoveFromSelllist(
  cardIds: number[],
  idempotencyKey?: string,
): Promise<{ removedCount: number }> {
  return request<{ removedCount: number }>('/selllist/bulk', {
    method: 'DELETE',
    body: { cardIds },
    idempotencyKey,
  })
}

export async function getSelllistShareToken(): Promise<ShareTokenResponse> {
  return request<ShareTokenResponse>('/selllist/share_token')
}

export async function regenerateSelllistShareToken(idempotencyKey?: string): Promise<ShareTokenResponse> {
  return request<ShareTokenResponse>('/selllist/regenerate_token', { method: 'POST', idempotencyKey })
}

export async function getSharedSelllist(shareToken: string): Promise<SharedSelllistResponse> {
  return request<SharedSelllistResponse>(`/shared/selllist/${shareToken}`)
}

export async function markSelllistItemSold(
  cardId: number,
  idempotencyKey?: string,
): Promise<MarkSelllistItemSoldResponse> {
  return request<MarkSelllistItemSoldResponse>(`/selllist/card/${cardId}/sold`, {
    method: 'POST',
    idempotencyKey,
  })
}
